import { put, call, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { addEncouragementGroupFail, addEncouragementGroupLoad, addEncouragementGroupSuccess, editEncouragementGroupLoad, encouragementGetAllDataFail, encouragementGetAllDataLoad, encouragementGetAllDataSuccess, encouragementGroupListFail, encouragementGroupListLoad, encouragementGroupListSuccess, encouragementPostListFail, encouragementPostListLoad, encouragementPostListSuccess, encouragementScoreLoad, encouragmentScoreSuccess, engagementGroupDeleteFailed, engagementGroupDeleteLoad, engagementGroupDeleteSuccess, groupCreatePostFail, groupCreatePostLoad, groupCreatePostSuccess, toxicGroupPostLoad } from '../slices/encouragementgroups.slice';
import { addEncouragementGroupApi, createPost, editEncouragementGroupApi, encouragementGetAllDataApi, encouragementgroupDeleteApi, encouragementGroupListApi, encouragementPostlistApi, encourgmentScoreApi, toxicApi } from '../Api/api';
import { toxicError } from '../slices/common.slice';


function* addEncouragementGroupSaga(action) {
    try {
        const response = yield call(addEncouragementGroupApi, action.payload);
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(addEncouragementGroupSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(addEncouragementGroupFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(addEncouragementGroupFail());
    }
}

function* editEncouragementGroupSaga(action) {
    try {
        const response = yield call(editEncouragementGroupApi, action.payload);
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(addEncouragementGroupSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(addEncouragementGroupFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(addEncouragementGroupFail());
    }
}

function* encouragementGroupListSaga(action) {
    try {
        const response = yield call(encouragementGroupListApi, action.payload);
        if (response?.status == 0) {
            yield put(encouragementGroupListSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(encouragementGroupListFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(encouragementGroupListFail());
    }
}


function* toxicGroupSaga(action) {
    try {

        console.log(action, "action");
        const toxicData = {
            apiKey: action.payload.apiKey,
            comment: action.payload.comment
        }
        const response = yield call(toxicApi, toxicData);
        if (response?.status == 0) {

            const data = response.result?.data?.data?.attributeScores?.TOXICITY?.summaryScore?.value *
                100 >
                70;

            const postPayload = action.payload.form


            if (!data) {

                const response = yield call(createPost, postPayload);
                if (response?.status == 0) {
                    toast.success(response?.result?.message)
                    yield put(groupCreatePostSuccess(response?.result?.data));
                }
                else {
                    toast.error(response?.result?.message)
                    yield put(groupCreatePostFail());
                }
            } else {
                toast.error("Please Don't use Abusive language");
            }
        }
        else {
            yield put(toxicError())

        }
    } catch (error) {
        toast.error(error)
        yield put(toxicError());
    }



}


function* groupCreatePostSaga(action) {
    try {
        const response = yield call(createPost, action.payload);
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(groupCreatePostSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(groupCreatePostFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(groupCreatePostFail());
    }
}

function* encouragementPostListSaga(action) {
    try {
        const response = yield call(encouragementPostlistApi, action.payload);
        if (response?.status == 0) {
            yield put(encouragementPostListSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(encouragementPostListFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(encouragementPostListFail());
    }

}

function* encouragementGetAllDataSaga(action) {
    try {
        const response = yield call(encouragementGetAllDataApi, action.payload);
        if (response?.status == 0) {
            yield put(encouragementGetAllDataSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(encouragementGetAllDataFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(encouragementGetAllDataFail());
    }

}

function* scoreSaga() {
    try {
        const data = yield call(encourgmentScoreApi);
        if (data.status === 0) {
            yield put(encouragmentScoreSuccess(data?.result?.data));
        }
        else {

        }
    }
    catch (e) {

    }
}



function* deleteEncouragementGroupSaga(action) {
    try {
        const data = yield call(encouragementgroupDeleteApi, action.payload);
        if (data.status === 0) {
            yield put(engagementGroupDeleteSuccess());
            toast.success(data?.result?.message);
            yield put(encouragementGroupListLoad());

        } else {
            yield put(engagementGroupDeleteFailed());
            toast.error(data?.result?.message);
        }
    } catch (error) {
        yield put(engagementGroupDeleteFailed());
        toast.error(error);
    }
}



export default function* rootEncouragementgroupsSaga() {

    yield takeLatest(encouragementGetAllDataLoad.type, encouragementGetAllDataSaga)
    yield takeLatest(addEncouragementGroupLoad.type, addEncouragementGroupSaga)
    yield takeLatest(editEncouragementGroupLoad.type, editEncouragementGroupSaga)
    yield takeLatest(encouragementGroupListLoad.type, encouragementGroupListSaga)
    yield takeLatest(groupCreatePostLoad.type, groupCreatePostSaga);
    yield takeLatest(encouragementPostListLoad.type, encouragementPostListSaga)
    yield takeLatest(encouragementScoreLoad.type, scoreSaga);
    yield takeLatest(toxicGroupPostLoad.type, toxicGroupSaga);
    yield takeLatest(engagementGroupDeleteLoad.type, deleteEncouragementGroupSaga);


}
